<template>
  <div class="dados mt-5">
    <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Meus Dados</h1>
    <hr class="linha-amarela ml-2" />

    <div class="container col">
      <i class="fas fa-mobile fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Material de divulgação
      </h4>

      <div class="row mt-3">
        <div class="col-md-9 form-group">
          <label for="email" class="font-weight-bold">Link de acesso para todo material de divulgação</label><br />
          <input
            type="text"
            class="form-control"
            v-model="link_apk"
            readonly
          />
        </div>
        <div :class="widthValid == true ? 'col-md-3 form-group' : 'col-md-3 form-group mt-4'">
          <button class="btn btn-success btn-block mt-2" @click="copyToClipboard()">
            <i class="fas fa-copy mr-2"></i>Copiar link
          </button>
        </div>
      </div>

      <hr />

      <i class="fas fa-sign-in-alt fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados de Acesso
      </h4>

      <div class="row col mt-3">
        <div class="col-md-4 form-group">
          <label for="email" class="font-weight-bold">E-mail:</label><br />
          <input
            type="text"
            class="form-control"
            v-model="dados.email"
            readonly
          />
        </div>

        <div class="col-md-4 form-group">
          <label class="font-weight-bold">Senha:</label><br />
          <input
            type="password"
            class="form-control"
            v-model="data.password"
            placeholder="******"
          />
          <p class="error-message text-danger" v-if="ErrorMessages.password !== null">
            {{ ErrorMessages.password }}
          </p>
        </div>

        <div class="col-md-4 form-group">
          <label class="font-weight-bold">Confirme a senha:</label><br />
          <input
            type="password"
            class="form-control"
            v-model="data.repassword"
            placeholder="******"
          />
          <p class="error-message text-danger" v-if="ErrorMessages.confirmPassword !== null">
            {{ ErrorMessages.confirmPassword }}
          </p>
        </div>

        <div class="form-group text-center col-md-12">
          <button class="btn btn-success text-white" @click="editarSenha()">
            <i class="fas fa-key mr-2"></i>Atualizar senha
          </button>
        </div>
      </div>

      <hr />

      <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados da Conta
      </h4>
      <div class="row mb-4">
        <div class="col-6 mt-2">
          <label>Nome:</label>
          <input type="text" class="form-control" v-model="dados.nome" placeholder="Informe o nome do vendedor">
        </div>

        <div class="col-6 mt-2">
          <label>Sobrenome:</label>
          <input type="text" class="form-control" v-model="dados.sobrenome" placeholder="Informe o sobrenome do vendedor">
        </div>

        <div class="col-6 mt-2">
          <label>E-mail:</label>
          <input type="text" class="form-control" v-model="dados.email" placeholder="Informe o email do vendedor">
        </div>

        <div class="col-6 mt-2">
          <label>CPF / CNPJ:</label>
          <input type="text" class="form-control" v-model="dados.cpf_cnpj" placeholder="###.###.###-## OU ##.###.###/####-##" v-mask="['###.###.###-##', '##.###.###/####-##']"> 
        </div>

        <div class="col-6" v-if="empresa == true">
          <label>Nome fantasia:</label>
          <input type="text" class="form-control" v-model="dados.nome_fantasia" placeholder="Informe o nome fantasia do vendedor">
        </div>

        <div class="col-6" v-if="empresa == true">
          <label>Razão social:</label>
          <input type="text" class="form-control" v-model="dados.razao_social" placeholder="Informe a razão social do vendedor">
        </div>

        <div class="col-6 mt-2">
          <label>Telefone:</label>
          <input type="text" class="form-control" v-model="dados.telefone" placeholder="(##) ####-####" v-mask="'(##) ####-####'">
        </div>

        <div class="col-6 mt-2">
          <label>WhatsApp:</label>
          <input type="text" class="form-control" v-model="dados.whatsapp" placeholder="(##) # ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
        </div>

        <div class="col-12 mt-4 text-center">
          <button class="btn btn-success" @click="updateGerente()">
            <i class="fas fa-save mr-2"></i>Atualizar dados
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";

export default {
  name: "MeusDadosGerente",
  mixins: [makeToast],

  data: () => ({
    data: {
      email: null,
      password: null,
      repassword: null
    },
    empresa: false,
    widthValid: false,
    link_apk: '',
    dados: {
      nome: null,
      sobrenome: null,
      cpf_cnpj: null,
      nome_fantasia: null,
      razao_social: null,
      telefone: null,
      whatsapp: null,
      id: null,
      commit: true,
      nota: '',
    },
    ErrorMessages: {
      password: null,
      confirmPassword: null,
    },
  }),

  watch: {
    'dados.cpf_cnpj': function() {
      this.empresa = false;
      if(this.dados.cpf_cnpj.length > 14) {
        this.empresa = true;
      }
    }
  },

  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },

  created() {
    var larguraTela = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    if(larguraTela < 500) {
      this.widthValid = true;
    }

    const item = this.dadosUsuario.informacoes;

    var cpf = this.dadosUsuario.cnpj;
    if(this.dadosUsuario.cpf != null) {
      cpf = this.dadosUsuario.cpf;
    }

    this.dados.nome = item.nome;
    this.dados.sobrenome = item.sobrenome;
    this.dados.email = this.dadosUsuario.email;
    this.dados.cpf_cnpj = cpf;
    this.dados.nome_fantasia = item.nome_fantasia;
    this.dados.razao_social = item.razao_social;
    this.dados.telefone = item.telefone;
    this.dados.whatsapp = item.whatsapp;
    this.dados.nota = item.nota;
    this.dados.id = item.user_id;

    this.link_apk = item.link_apk && item.link_apk == '' ? 'Link não liberado até o momento!' : item.link_apk;
  },

  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.link_apk);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    editarSenha() {
      if(this.validatePassword() == true) {
        const data = {
          password: this.data.password,
          id: this.dadosUsuario.id
        }

        this.$store.dispatch('startLoader');
        this.$store.dispatch('gerente/updateSenha', data)
          .then((response) => {
            if(response.data.error == false) {
              this.data.password = null;
              this.data.repassword = null;
              this.makeToast('sucesso', response.data.message, 'success');
            } else {
              this.makeToast('Oopss', response.data.message, 'danger')
            }
            
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao atualizar!', 'danger')
          })
          .finally(() => {
            this.$store.dispatch('endLoader')
          });
      }
    },
    updateGerente() {
      const error = this.validForm();
      if(error == false) {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('admin/updateGerenteConta', this.dados)
          .then((response) => {
            if(response.data.error == false) {
                this.makeToast('Sucesso', response.data.message, 'success');
                localStorage.setItem('dadosUsuario', JSON.stringify(response.data.info));
              } else {
                this.makeToast('Oopss', response.data.message, 'danger');
              }
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao atualizar gerente!', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          })
        }
    },
    validForm() {
      var error = false;

      if(this.dados.nome == null || this.dados.nome == '') {
        this.makeToast('Oopss', 'Informe o nome!', 'danger');
        error = true;
      }

      if(this.dados.sobrenome == null || this.dados.sobrenome == '') {
        this.makeToast('Oopss', 'Informe o sobrenome!', 'danger');
        error = true;
      }

      if(this.dados.email == null || this.dados.email == '') {
        this.makeToast('Oopss', 'Informe o e-mail!', 'danger');
        error = true;
      }

      if(this.dados.cpf_cnpj == null || this.dados.cpf_cnpj == '') {
        this.makeToast('Oopss', 'Informe o CPF/CNPJ!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.nome_fantasia == null || this.dados.nome_fantasia == '')) {
        this.makeToast('Oopss', 'Informe o nome fantasia!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.razao_social == null || this.dados.razao_social == '')) {
        this.makeToast('Oopss', 'Informe a razão social!', 'danger');
        error = true;
      }

      if((this.dados.telefone == '' || this.dados.telefone == null) && (this.dados.whatsapp == null || this.dados.whatsapp == '')) {
        this.makeToast('Oopss', 'Informe o telefone ou whatsapp!', 'danger');
        error = true;
      }

      return error;
    },
    validatePassword() {
      let isValid = true;

      if (!this.$validate.password(this.data.password)) {
        this.ErrorMessages.password = 'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      } else {
        this.ErrorMessages.password = null;
      }

      if (this.data.repassword !== this.data.password) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      } else {
        this.ErrorMessages.confirmPassword = null;
      }

      return isValid;
    },
  },
};
</script>
